/** DRW-9 — the sheet TYPE tag, derived from the title text only. Constant table, first match
 *  wins, never a sheet number or a sheet name. */
export const TYPE_RULES = [
  ["Enlarged Plan", /\benlarged\b/i],
  ["Finish Plan", /\bfinish(es)?\b.*\bplan|\bplan\b.*\bfinish(es)?\b|\bfinish schedule\b/i],
  ["Schedule", /\bschedule|\blegend\b/i],
  ["Elevation", /\belevation/i],
  ["Section/Detail", /\bsection|\bdetail|\btypes\b|\bmounting heights?\b/i],
  ["Floor Plan", /\b(floor|roof|site|ceiling|reflected|demolition|demo|level|framing|foundation|plumbing|mechanical|electrical|lighting|power|fire)\b.*\bplan|\bplans?\b|\blevel\s*\d/i],
];
export const TYPE_ORDER = ["Floor Plan", "Enlarged Plan", "Finish Plan", "Elevation", "Section/Detail", "Schedule", "Other"];

export const sheetTypeOf = (title) => {
  const t = String(title || "");
  for (const [tag, re] of TYPE_RULES) if (re.test(t)) return tag;
  return "Other";
};

export const naturalKey = (num) => String(num || "").split(/(\d+)/).map((p) => (/^\d+$/.test(p) ? p.padStart(6, "0") : p.toLowerCase())).join("");
export const bySheetNumber = (a, b) => naturalKey(a.sheet_number).localeCompare(naturalKey(b.sheet_number));

/** The sheets of the current sheet's group (the whole set when the set is not grouped), in natural order. */
export const groupSiblings = (sheets, current) => {
  const cur = sheets.find((s) => s.id === current);
  const g = cur?.group || "";
  return sheets.filter((s) => (g ? s.group === g : true) && s.is_current !== false).sort(bySheetNumber);
};
